var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrophy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF366",
  d: "M15.682 8.487c.75-1.694 1.14-3.67 1.343-5.142h1.703c-.284 1.07-1.12 3.887-3.046 5.142M1.154 3.345h1.688c.207 1.472.604 3.465 1.363 5.166C2.26 7.266 1.433 4.415 1.154 3.345m3.845 6.407c.854 1.306 2.016 2.373 3.594 2.745-.259 1.255-.885 4.63-2.364 5.299h7.357c-1.473-.67-2.1-4.028-2.36-5.284 1.616-.359 2.798-1.418 3.663-2.749 1.549-.448 2.844-1.642 3.796-3.5.902-1.759 1.178-3.5 1.19-3.572.022-.147-.021-.211-.12-.324-.098-.113-.242-.092-.393-.092H17.14c.113-1.205.106-2.007.106-2.007V0H2.616v.268s-.006.802.11 2.007H.523c-.15 0-.294-.024-.392.088-.098.112-.143.216-.12.363.01.073.275 1.764 1.165 3.523.95 1.878 2.255 3.065 3.823 3.503z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEB00",
  d: "M1.149 3.345h1.688c.207 1.472.604 3.465 1.363 5.166-1.943-1.245-2.772-4.096-3.051-5.166M2.611 0h7.185v17.796H6.224c1.479-.67 2.116-4.043 2.375-5.298-1.578-.371-2.75-1.439-3.605-2.744-1.568-.439-2.873-1.623-3.823-3.5a12.975 12.975 0 01-1.166-3.53c-.021-.146.023-.25.121-.362.098-.112.241-.087.392-.087h2.203a21.196 21.196 0 01-.11-2.007V0zm2.56 17.796h4.693v.669H5.17v-.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5DF3D",
  d: "M5.17 18.331h4.694v1H5.17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EACB14",
  d: "M17.139 2.275l.455.002-.108 1.068h-.461zm-14.414 0l-.455.002.107 1.068h.462z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFEA6F",
  d: "M9.796 17.796h4.694v1H9.796z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5DF3D",
  d: "M9.796 18.331h4.694v1H9.796z"
}))));
export default SvgTrophy;